import { render, staticRenderFns } from "./BidDashboardModule.vue?vue&type=template&id=46ba70b4&scoped=true"
import script from "./BidDashboardModule.vue?vue&type=script&lang=js"
export * from "./BidDashboardModule.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardModule.vue?vue&type=style&index=0&id=46ba70b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba70b4",
  null
  
)

export default component.exports